import {AuthState, useUserContext} from 'Contexts/UserContext/UserContext';
import React from 'react';
import {Upgrade} from 'Views/Upgrade';
import {SignIn} from './Auth/SignIn';
import {PageContainer} from './PageContainer';

interface Props {
    dark?: boolean;
    protectedRoute?: boolean;
    requirePaid?: boolean;
}

export const RouteContainer: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    dark,
    protectedRoute,
    requirePaid,
}) => {
    const userContext = useUserContext();

    if (protectedRoute && !userContext.user) {
        return (
            <PageContainer dark={dark}>
                <SignIn />
            </PageContainer>
        );
    }

    if (requirePaid && userContext.status !== AuthState.SIGNED_IN_PAID) {
        return (
            <PageContainer dark={dark}>
                <Upgrade />
            </PageContainer>
        );
    }

    return <PageContainer dark={dark}>{children}</PageContainer>;
};
